"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalatttvDisclaimerNewModalCms = void 0;
var LegalatttvDisclaimerNewShortPathlCms_cms_1 = require("./LegalatttvDisclaimerNewShortPathlCms.cms");
var LegalatttvDisclaimerNewModalCms = /** @class */ (function () {
    function LegalatttvDisclaimerNewModalCms() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/prod/legalmodal/offers/wireline/checkout/atttvnowpymtschedule1lm.cmsfeed.js',
        ];
        this.legalShortPath = new LegalatttvDisclaimerNewShortPathlCms_cms_1.LegalatttvDisclaimerNewShortPathCms();
    }
    return LegalatttvDisclaimerNewModalCms;
}());
exports.LegalatttvDisclaimerNewModalCms = LegalatttvDisclaimerNewModalCms;
//# sourceMappingURL=LegalatttvDisclaimerNewModalCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/LegalatttvDisclaimerNewModalCms.cms.js
// module id = 2274
// module chunks = 8